export const REVIEWS = [
  {
    name: "Samantha",
    rating: 5,
    date: "Recently",
    text: "Absolutely amazing service! She did such a fantastic job cleaning my home and paid attention to every little detail. Everything was left spotless, fresh and beautifully clean. She was also lovely, professional and reliable. I'm so happy with the service and would definitely recommend her to anyone looking for a great house cleaner!",
  },
  {
    name: "Leo Tran",
    rating: 5,
    date: "Recently",
    text: "Great service, fair prices and they come on time. Highly recommended.",
  },
  {
    name: "Hamid Maafa",
    rating: 5,
    date: "Recently",
    text: "Very professional, fast and accommodating.",
  },
];

export const FAQS = [
  {
    q: "Which areas of Melbourne do you service?",
    a: "We provide residential house cleaning across West Melbourne, East Melbourne and North Melbourne. Not sure if we can reach your home? Just ask when you request your free quote.",
  },
  {
    q: "What are your opening hours?",
    a: "We operate Monday to Friday, 9:00 AM to 4:30 PM. We're closed on Saturdays and Sundays. You can send a quote request or WhatsApp message any time and we'll get back to you during business hours.",
  },
  {
    q: "Do you offer same-day cleaning?",
    a: "Same-day cleaning is available depending on our schedule and availability. Give us a call on 0427 510 406 or message us on WhatsApp and we'll let you know if we can fit you in.",
  },
  {
    q: "Do you offer emergency cleaning?",
    a: "Emergency cleaning is sometimes available depending on our current schedule. Please contact us directly and we'll do our best to help.",
  },
  {
    q: "Do you bring your own equipment and cleaning products?",
    a: "Yes. We supply our own professional cleaning equipment and cleaning products, so there's nothing you need to provide.",
  },
  {
    q: "Are you insured?",
    a: "Yes. JK House Cleaning holds Public Liability Insurance for your peace of mind.",
  },
  {
    q: "Are you a registered business?",
    a: "Yes. We are an ABN-registered Australian business (ABN 63 130 899 876).",
  },
  {
    q: "Are your cleaners police checked?",
    a: "Yes. We are police checked, so you can feel confident and secure with us in your home.",
  },
  {
    q: "How do I get a quote?",
    a: "Getting a free quote is easy. Complete our quick online quote request, call us on 0427 510 406, or message us on WhatsApp. We'll review your details and prepare a personalised estimate.",
  },
  {
    q: "Do I need to be home during the clean?",
    a: "Not necessarily. Many customers arrange key access, a lockbox or building access instead. You can let us know your preferred access arrangements in your quote request.",
  },
  {
    q: "Do you offer flexible scheduling?",
    a: "Absolutely. We offer weekly, fortnightly, monthly and one-off cleaning, and we'll work around a schedule that suits your household.",
  },
];
